export default __webpack_public_path__ + "static/media/oola_logo_blue.abc82ad4.svg";